import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

const MODULES = [CommonModule, TranslateModule];
@Component({
  selector: 'app-no-warning',
  templateUrl: './no-warning.component.html',
  imports: [...MODULES],
})
export class NoWarningComponent {
  type = input<string>();
  message = input<string>();
}
